/* import __COLOCATED_TEMPLATE__ from './locale-tab-control-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();